import React from "react";
import { CiSearch } from "react-icons/ci";

const SearchBar = ({ text, onChange }) => {
  return (
    <div className="w-1/2 lg:w-[400px] flex justify-start items-center border rounded-lg px-3 bg-white">
      <CiSearch />
      <input
        type="text"
        className="w-full py-2 focus:outline-none px-3 text-black/80"
        placeholder={text}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchBar;
